// extracted by mini-css-extract-plugin
export default {"list":"Billing_list__z4zXU","item":"Billing_item__j3l8Q","box":"Billing_box__QRnkZ","image":"Billing_image__fVLZ0","name":"Billing_name__8ZUDV"};